import yup from 'yup'
import uniq from 'lodash/uniq'

export function getValidationSchema (defaultExpertBriefValue) {
  return yup.object().shape({
    office: yup
      .object()
      .shape({
        id: yup
          .number()
          .typeError(
            'Enter / select client office associated with the project.'
          )
      })
      .typeError('Enter / select client office associated with the project.'),
    clients: yup.array().min(1, 'Client contact field is required.'),
    projectName: yup.string().required('Project name field is required.'),
    employees: yup.array().min(1, 'Atheneum contact field is required.'),
    bdContactId: yup
      .number()
      .integer()
      .nullable(),
    projectCategoryId: yup
      .number()
      .nullable(true),
    projectTypeId: yup
      .string()
      .required('Project type field is required.')
      .typeError('Project type field is required.'),
    subIndustry: yup
      .object()
      .shape({
        id: yup.number().required('Industry / subindustry field is required.')
      })
      .typeError('Industry / subindustry field is required.'),
    background: yup.string().required('Background field is required.'),
    interviewTarget: yup
      .number()
      .min(1, 'The Target no. of Interviews must be at least 1')
      .typeError('The Target no. of Interviews must be a number')
      .required('Target no. of Interviews field is required'),
    applyBeforeDate: yup.date().nullable(),
    id: yup.number(),
    segments: yup.array().when('id', {
      is: undefined,
      then: yup.array().of(
        yup.object().shape({
          name: yup.string().required('Segment title field is required'),
          numberOfExpert: yup
            .number()
            .min(1, 'No. of required Experts must be at least 1')
            .typeError('No. of required Experts field is required'),
          expertBrief: yup
            .string()
            .required('Expert brief is required')
            .test(
              'isNotDefault',
              'Please provide a short brief of client requirements for this segment.',
              value => value !== defaultExpertBriefValue
            ),
          screeningQuestions: yup.array().of(
            yup.object().shape({
              question: yup.string()
            })
          )
        })
      )
    }),
    segmentNameNotRepeating: yup.mixed().when('id', {
      is: undefined,
      then: yup
        .mixed()
        .test(
          'segmentNameNotRepeating',
          'You are using the same segment title in multiple fields',
          function () {
            const segments = this.parent.segments
              .map(segment => segment.name.trim().toLowerCase())
              .filter(name => !!name)

            return segments.length === uniq(segments).length
          }
        )
    })
  })
}
